export const STATIC_CLASSES = Object.freeze({
	content: 'q-numeric-content',
})
